'use client'

import type { CSSProperties } from 'react'
import { cx } from './utils/cx'
import { FileThumb, type FileKind } from './FileThumb'
import { fmtSize } from './utils/fmtSize'

export interface FileRowFile {
  id: string | number
  name: string
  size: number
  kind: FileKind
  meta?: string
}

interface FileRowProps {
  file: FileRowFile
  onRemove?: (id: FileRowFile['id']) => void
  onDownload?: (file: FileRowFile) => void
  size?: 'lg'
  className?: string
  style?: CSSProperties
}

export function FileRow({ file, onRemove, onDownload, size, className, style }: FileRowProps) {
  return (
    <div className={cx('st-file-row', size, className)} style={style} data-kind={file.kind}>
      <FileThumb kind={file.kind} size={size} />
      <div>
        <div className="name">{file.name}</div>
        <div className="sub">
          {file.kind?.toUpperCase()} · {file.meta || 'chunk 4 MB · SHA-256 ok'}
        </div>
      </div>
      <div className="size">{fmtSize(file.size)}</div>
      {onDownload && (
        <button
          type="button"
          className="st-file-dl"
          onClick={(e) => {
            e.stopPropagation()
            onDownload(file)
          }}
          aria-label="Download">
          ↓ Download
        </button>
      )}
      {onRemove && (
        <button className="x" onClick={() => onRemove(file.id)} aria-label="Remove">
          ×
        </button>
      )}
    </div>
  )
}
